/**
 * The Monteau - Size Finder (cm-sf)
 * Clean-Room Luxury Storefront Standard
 * Supports US/Metric units, instant recommendation, snugger/best fit options,
 * full interactive size chart, and native bundle sync in drawer.
 */
(function() {
  if (window.__cmSf) return;
  window.__cmSf = true;

  var S = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL'];
  // Weight bands in kg: 10 kg per size, [min, max) so boundary goes to bigger size
  var W_KG = [60, 70, 80, 90, 100, 110, 120, 130, 140, Infinity];
  var W_LB = [132, 154, 176, 198, 220, 243, 265, 287, 309, Infinity];
  // Body measurements per size, aligned with weight bands
  var WA_IN = [27, 31.5, 35, 39, 43.5, 47, 51, 54.5, 58, 61.5];
  var H_IN = [37, 41.5, 45.5, 48, 51, 55.5, 59, 62.5, 66, 69.5];
  var LEG_IN = [31.1, 31.9, 32.7, 33.5, 34.3, 35.0, 35.8, 36.6, 37.4, 38.2];

  // Factory spec: unstretched -> fully stretched
  var G_CM = [
    [58, 75, 68, 88, 79],
    [62, 81, 72, 94, 81],
    [66, 86, 76, 99, 83],
    [70, 91, 80, 104, 85],
    [74, 96, 84, 109, 87],
    [78, 101, 88, 114, 89],
    [82, 107, 92, 120, 91],
    [86, 112, 96, 125, 93],
    [90, 117, 100, 130, 95],
    [94, 122, 104, 135, 97]
  ];
  var G_IN = [
    [22.8, 29.7, 26.8, 34.8, 31.1],
    [24.4, 31.7, 28.4, 36.9, 31.9],
    [26.0, 33.8, 29.9, 38.9, 32.7],
    [27.6, 35.8, 31.5, 40.9, 33.5],
    [29.1, 37.9, 33.1, 43.0, 34.3],
    [30.7, 39.9, 34.7, 45.0, 35.0],
    [32.3, 42.0, 36.2, 47.1, 35.8],
    [33.9, 44.0, 37.8, 49.1, 36.6],
    [35.4, 46.1, 39.4, 51.2, 37.4],
    [37.0, 48.1, 40.9, 53.2, 38.2]
  ];

  var ALIAS = {
    '2XL': ['2XL', 'XXL'],
    'XXL': ['2XL', 'XXL'],
    '3XL': ['3XL', 'XXXL'],
    'XXXL': ['3XL', 'XXXL'],
    '4XL': ['4XL', 'XXXXL'],
    'XXXXL': ['4XL', 'XXXXL'],
    '5XL': ['5XL', 'XXXXXL'],
    'XXXXXL': ['5XL', 'XXXXXL']
  };

  var unit = 'us', box, scope, chosen = null, COLORS = {}, K = { el: null, home: null, mo: null, last: null }, applyT, lookT;

  function $(s) { return box ? box.querySelector(s) : document.querySelector(s); }
  function num(el) {
    var v = parseFloat((el && el.value || '').replace(',', '.'));
    return isNaN(v) ? 0 : v;
  }
  function band(arr, v) {
    for (var i = 0; i < arr.length; i++) {
      if (v <= arr[i]) return i;
    }
    return arr.length - 1;
  }
  function r0(v) { return Math.round(v); }
  function rng(A, i, us) {
    var lo = i ? A[i - 1] : 0, hi = A[i];
    if (!us) { lo = r0(lo * 2.54); hi = r0(hi * 2.54); }
    return i ? lo + '–' + hi : 'under ' + hi;
  }

  function table() {
    var tb = $('[data-cm-sf-table] tbody'), rows = '', us = unit === 'us';
    if (tb) {
      for (var i = 0; i < S.length; i++) {
        var lo = i ? W_LB[i - 1] : 0, hi = W_LB[i];
        var w = us ? (i ? (i === S.length - 1 ? lo + '+' : lo + '–' + hi) : 'up to ' + hi)
                   : (i ? (i === S.length - 1 ? W_KG[i - 1] + '+' : W_KG[i - 1] + '–' + W_KG[i]) : 'up to ' + W_KG[i]);
        var wa = rng(WA_IN, i, us), hh = rng(H_IN, i, us);
        var leg = us ? LEG_IN[i].toFixed(1) + '″' : r0(LEG_IN[i] * 2.54) + ' cm';
        rows += '<tr data-i="' + i + '"><td>' + S[i] + '</td><td>' + w + '</td><td>' + wa + '</td><td>' + hh + '</td><td>' + leg + '</td></tr>';
      }
      tb.innerHTML = rows;
    }

    var gb = $('[data-cm-sf-gtable] tbody');
    if (gb) {
      var G = us ? G_IN : G_CM, u = us ? '″' : ' cm', g = '';
      for (var k = 0; k < S.length; k++) {
        g += '<tr data-i="' + k + '"><td>' + S[k] + '</td><td>' + G[k][0] + '–' + G[k][1] + '</td><td>' + G[k][2] + '–' + G[k][3] + '</td><td>' + G[k][4] + u + '</td></tr>';
      }
      gb.innerHTML = g;
      var gu = $('[data-cm-sf-gu]');
      if (gu) gu.textContent = us ? 'inches' : 'cm';
    }

    var thw0 = $('[data-cm-sf-th-w]'); if (thw0) thw0.textContent = us ? 'Weight (lbs)' : 'Weight (kg)';
    var thh = $('[data-cm-sf-th-h]'); if (thh) thh.textContent = us ? 'Hips (in)' : 'Hips (cm)';
    var thw = $('[data-cm-sf-th-wa]'); if (thw) thw.textContent = us ? 'Waist (in)' : 'Waist (cm)';
    mark(chosen ? S.indexOf(chosen) : -1);
  }

  function mark(i) {
    if (!box) return;
    box.querySelectorAll('[data-cm-sf-table] tr[data-i],[data-cm-sf-gtable] tr[data-i]').forEach(function(tr) {
      tr.classList.toggle('is-me', +tr.dataset.i === i);
    });
  }

  function hasH() {
    if (unit === 'us') {
      var ftEl = $('[data-cm-sf-ft]'), inchEl = $('[data-cm-sf-inch]');
      if (!ftEl || !inchEl || ftEl.value.trim() === '' || inchEl.value.trim() === '') return false;
      var hIn = num(ftEl) * 12 + num(inchEl);
      return hIn >= 54 && hIn <= 80;
    } else {
      var cmEl = $('[data-cm-sf-cm]');
      if (!cmEl || cmEl.value.trim() === '') return false;
      var hIn = num(cmEl) / 2.54;
      return hIn >= 54 && hIn <= 80;
    }
  }

  function legNote(i) {
    var hIn = unit === 'us'
      ? num($('[data-cm-sf-ft]')) * 12 + num($('[data-cm-sf-inch]'))
      : num($('[data-cm-sf-cm]')) / 2.54;
    if (hIn < 54 || hIn > 80) return '';
    var r = LEG_IN[i] / (hIn * 0.5);
    var ht = unit === 'us'
      ? Math.floor(hIn / 12) + '′' + Math.round(hIn % 12) + '″'
      : Math.round(hIn * 2.54) + ' cm';
    if (r < 0.93) return ' At ' + ht + ' they end a little above your ankle.';
    if (r > 1.06) return ' At ' + ht + ' they gather softly at your ankle.';
    return ' At ' + ht + ' the leg ends at your ankle.';
  }

  /* ---------- STEP 1: CALCULATE SIZE ---------- */
  function calc() {
    var wv = num($('[data-cm-sf-w]')), hv = num($('[data-cm-sf-hips]'));
    var lb = unit === 'us' ? wv : wv * 2.2046;
    var hin = unit === 'us' ? hv : hv / 2.54;
    var res = $('[data-cm-sf-res]'), alt = $('[data-cm-sf-alt]'), hint = $('[data-cm-sf-hint]');
    var best, snug = -1, why;

    if (!hasH() || !(lb >= 70 && lb <= 600)) {
      if (hint) {
        hint.textContent = (lb >= 70 && lb <= 600)
          ? (unit === 'us' ? 'Now add your height (feet and inches) to see your size.' : 'Now add your height to see your size.')
          : 'Enter your weight and height and we\'ll match you to the chart.';
        hint.hidden = false;
      }
      if (res) res.hidden = true;
      if (alt) alt.hidden = true;
      mark(-1);
      return;
    }

    if (hin >= 24 && hin <= 70) {
      best = band(H_IN, hin);
      why = 'Matched on your hips, the most precise way to size compression.';
    } else if (lb >= 70 && lb <= 600) {
      var kg = unit === 'metric' ? wv : (lb / 2.2046), i = 0;
      while (i < S.length - 1 && kg >= W_KG[i]) i++;
      best = i;
      if (i > 0 && kg - W_KG[i - 1] < 1) {
        snug = i - 1;
        why = 'You\'re right on the line between ' + S[i - 1] + ' and ' + S[i] + '. ' + S[i - 1] + ' gives a closer sculpting fit; ' + S[i] + ' gives more ease.';
      } else {
        why = 'Women your weight and height wear ' + S[i] + ' most comfortably: firm hold, no digging at the waist.';
      }
      if (kg > 150) why = S[9] + ' is our largest size. Add your hip measurement below to be sure.';
    } else {
      if (res) res.hidden = true;
      if (alt) alt.hidden = true;
      if (hint) hint.hidden = false;
      mark(-1);
      return;
    }

    why += legNote(best);
    if (hint) hint.hidden = true;
    if (res) res.hidden = false;

    var sizeEl = $('[data-cm-sf-size]'), titleEl = $('[data-cm-sf-title]'), whyEl = $('[data-cm-sf-why]');
    if (sizeEl) sizeEl.textContent = S[best];
    if (titleEl) titleEl.textContent = 'We recommend ' + S[best];
    if (whyEl) whyEl.textContent = why;

    if (alt) {
      if (snug >= 0) {
        alt.hidden = false;
        alt.innerHTML = '<button type="button" data-cm-sf-alt-size="' + S[snug] + '">Snugger<b>' + S[snug] + '</b></button>' +
                        '<button type="button" class="is-on" data-cm-sf-alt-size="' + S[best] + '">Best fit<b>' + S[best] + '</b></button>';
      } else {
        alt.hidden = true;
        alt.innerHTML = '';
      }
    }

    try {
      window.__cmSfUserFit = {
        recommended: S[best],
        chosen: S[best],
        fitType: snug >= 0 ? 'boundary' : 'direct',
        unit: unit,
        weight: wv,
        height: unit === 'us'
          ? (num($('[data-cm-sf-ft]')) * 12 + num($('[data-cm-sf-inch]')))
          : num($('[data-cm-sf-cm]'))
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'size_finder_calculated',
        recommended_size: S[best],
        fit_type: window.__cmSfUserFit.fitType,
        unit_system: unit,
        weight: wv
      });
    } catch(err) {}

    choose(S[best]);
  }

  function choose(size) {
    var first = !chosen;
    chosen = size;
    if (window.__cmSfUserFit) {
      window.__cmSfUserFit.chosen = size;
    }
    mark(S.indexOf(size));

    var s2SizeEl = $('[data-cm-sf-s2size]');
    if (s2SizeEl) s2SizeEl.textContent = size;

    var s2 = $('[data-cm-sf-step2]');
    if (s2) {
      s2.hidden = false;
      renderModalStep2(size);
    }

    clearTimeout(applyT);
    applyT = setTimeout(function() {
      applySize(size);
      look();
    }, first ? 50 : 350);

    if (first && s2) {
      setTimeout(function() {
        var bx = $('.cm-sf__box') || (box && box.querySelector('.cm-sf__box'));
        var y = s2.offsetTop - 140;
        if (bx && y > bx.scrollTop) {
          bx.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 700);
    }
  }

  function applySize(size) {
    var roots = [K.el, scope || document].filter(Boolean);
    var names = ALIAS[size] || [size];

    roots.forEach(function(root) {
      // 1. Select elements
      root.querySelectorAll('select').forEach(function(sel) {
        for (var k = 0; k < sel.options.length; k++) {
          var t = (sel.options[k].text || sel.options[k].value || '').trim().toUpperCase();
          var matched = false;
          for (var n = 0; n < names.length; n++) {
            var targetName = names[n].toUpperCase();
            if (t === targetName || t.indexOf(targetName) === 0 || t.split(/\s|\//)[0] === targetName) {
              matched = true;
              break;
            }
          }
          if (matched) {
            if (sel.selectedIndex !== k) {
              sel.selectedIndex = k;
              sel.dispatchEvent(new Event('input', { bubbles: true }));
              sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
            break;
          }
        }
      });

      // 2. Radio elements
      root.querySelectorAll('input[type=radio]').forEach(function(r) {
        var val = (r.value || '').trim().toUpperCase();
        for (var n = 0; n < names.length; n++) {
          if (val === names[n].toUpperCase() && !r.checked) {
            r.click();
            break;
          }
        }
      });
    });
  }

  /* ---------- STEP 2: BUNDLE INTEGRATION INSIDE DRAWER ---------- */
  function mountK() {
    if (K.el) return;
    // Look for external app bundle if present (do not detach native Monteau bundle cards from main buy box)
    var k = (scope && scope.querySelector('kaching-bundle')) ||
            document.querySelector('kaching-bundle');
    if (!k) return;

    K.home = document.createComment('cm-bundle-home');
    k.parentNode.insertBefore(K.home, k);
    var slot = $('[data-cm-sf-kslot]');
    if (slot) slot.appendChild(k);
    K.el = k;

    K.mo = new MutationObserver(function(list) {
      list.forEach(function(m) {
        if (m.type === 'attributes' && m.target.dataset && /col/i.test(m.target.dataset.name || '')) {
          K.last = m.target.dataset.value;
        }
      });
      clearTimeout(lookT);
      lookT = setTimeout(look, 80);
    });
    K.mo.observe(k, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-value', 'class', 'data-tier'] });

    k.addEventListener('click', onKClick);
    k.addEventListener('change', function(e) {
      if (e.target.tagName === 'SELECT' && COLORS[(e.target.value || '').toLowerCase()]) {
        K.last = e.target.value;
      }
      clearTimeout(lookT);
      lookT = setTimeout(look, 80);
    });
  }

  function unmountK() {
    if (!K.el || !K.home || !K.home.parentNode) return;
    K.el.removeEventListener('click', onKClick);
    if (K.mo) K.mo.disconnect();
    K.home.parentNode.insertBefore(K.el, K.home);
    K.home.remove();
    K.el = null;
    K.mo = null;
  }

  function onKClick(e) {
    // When clicking a color option in Monteau bundle
    var opt = e.target.closest('.mb-color-option');
    if (opt) {
      var v = opt.getAttribute('data-value');
      if (v) K.last = v;
      clearTimeout(lookT);
      lookT = setTimeout(look, 60);
      return;
    }

    if (e.target.closest('select, .kaching-bundles__swatch-dropdown, .kaching-bundles__bar-variant-select, .mb-sel-size')) return;

    if (e.target.closest('.kaching-bundles__bar, .mb-card') && chosen) {
      setTimeout(function() {
        applySize(chosen);
        look();
      }, 200);
    }
  }

  function selectedColors() {
    if (!K.el) return [];
    var out = [];

    // 1. Kaching bundles check
    var bar = K.el.querySelector('.kaching-bundles__bar--selected') || K.el;
    bar.querySelectorAll('.kaching-bundles__swatch-dropdown[data-name]').forEach(function(d) {
      if (/col/i.test(d.dataset.name) && d.dataset.value) out.push(d.dataset.value);
    });
    if (!out.length) {
      bar.querySelectorAll('select').forEach(function(s) {
        var v = s.value || '';
        if (COLORS[v.toLowerCase()]) out.push(v);
      });
    }

    // 2. Monteau Bundle (.mb-card.is-active) check
    if (!out.length) {
      var activeCard = K.el.querySelector('.mb-card.is-active') || K.el;
      activeCard.querySelectorAll('.mb-pair-row').forEach(function(row) {
        var hiddenColor = row.querySelector('.mb-hidden-color');
        var colorLabel = row.querySelector('.mb-color-name');
        var c = (hiddenColor && hiddenColor.value) || (colorLabel && colorLabel.textContent.trim()) || '';
        if (c) out.push(c);
      });
    }

    return out;
  }

  function look() {
    var cols = selectedColors();
    var img = $('[data-cm-sf-img]'), cap = $('[data-cm-sf-color]'), pairs = $('[data-cm-sf-pairs]');
    var main = (K.last && cols.indexOf(K.last) > -1) ? K.last : cols[0];

    if (main && COLORS[main.toLowerCase()] && img && img.getAttribute('src') !== COLORS[main.toLowerCase()]) {
      img.src = COLORS[main.toLowerCase()];
    }

    if (cap) {
      cap.hidden = !main;
      if (main) cap.textContent = main + (chosen ? ' · ' + chosen : '');
    }

    if (pairs) {
      if (cols.length > 1) {
        pairs.innerHTML = cols.map(function(c, i) {
          var u = COLORS[c.toLowerCase()] || (img && img.src) || '';
          return '<span' + (c === main ? ' class="is-on"' : '') + ' data-pair-col="' + c.toLowerCase() + '">' +
                 '<img src="' + u + '" alt="">' +
                 '<small>Pair ' + (i + 1) + '<br>' + c + '</small>' +
                 '</span>';
        }).join('');
        pairs.hidden = false;

        pairs.querySelectorAll('span[data-pair-col]').forEach(function(sp) {
          sp.addEventListener('click', function() {
            var colName = sp.getAttribute('data-pair-col');
            for (var k in COLORS) {
              if (k.toLowerCase() === colName) {
                K.last = k;
                look();
                break;
              }
            }
          });
        });
      } else {
        pairs.innerHTML = '';
        pairs.hidden = true;
      }
    }

    // Dynamic Price on ATC button
    updateModalAtcButton(chosen);
  }

  /* ==========================================================================
     MONTEAU STEP 2 BUNDLE & PAIR COLOR CUSTOMIZER
     ========================================================================== */
  var COLOR_SWATCH_MAP = {
    'black': '#222222',
    'beige': '#D9C5B2',
    'pink': '#E8A598',
    'blue': '#3D5A80',
    'navy': '#1B263B',
    'purple': '#8A5082',
    'light purple': '#B39EB5',
    'burgundy': '#6E1E3C',
    'gray': '#808080',
    'grey': '#808080',
    'brown': '#6E473B',
    'powder blue': '#A0BED9',
    'army green': '#4B5320',
    'yellow': '#E6AF2E'
  };

  var modalState = {
    tier: 2,
    qty: 2,
    pairs: [
      { color: 'Black' },
      { color: 'Beige' },
      { color: 'Purple' }
    ]
  };

  function getProductData() {
    try {
      var el = document.querySelector('[data-cm-sf-product-data]');
      return el ? JSON.parse(el.textContent) : null;
    } catch(e) {
      return null;
    }
  }

  function resolveVariantForColorAndSize(col, sz) {
    var pData = getProductData();
    if (!pData || !pData.variants || pData.variants.length === 0) return null;

    var normCol = (col || '').toLowerCase().trim();
    var normSz = (sz || '').toUpperCase().trim();
    var altSz = normSz === '2XL' ? 'XXL' : (normSz === 'XXL' ? '2XL' : normSz);

    for (var i = 0; i < pData.variants.length; i++) {
      var v = pData.variants[i];
      var vCol = (v.color || '').toLowerCase().trim();
      var vSz = (v.size || '').toUpperCase().trim();
      if (vCol === normCol && (vSz === normSz || vSz === altSz)) {
        return v;
      }
    }

    for (var j = 0; j < pData.variants.length; j++) {
      var v2 = pData.variants[j];
      var vSz2 = (v2.size || '').toUpperCase().trim();
      if (vSz2 === normSz || vSz2 === altSz) {
        return v2;
      }
    }

    return pData.variants[0];
  }

  function getAvailableColors() {
    var pData = getProductData();
    if (pData && pData.colors && pData.colors.length > 0) {
      return pData.colors;
    }
    return ['Purple', 'Black', 'Blue', 'Beige', 'Pink', 'Burgundy', 'Gray', 'Brown', 'Powder Blue', 'Army Green'];
  }

  function renderModalStep2(size) {
    if (!size) size = chosen || 'L';
    var s2 = $('[data-cm-sf-step2]');
    if (!s2) return;

    var s2SizeEl = $('[data-cm-sf-s2size]');
    if (s2SizeEl) s2SizeEl.textContent = size;

    var activePageCard = document.querySelector('.monteau-bundle-root .mb-card.is-active');
    if (activePageCard && activePageCard.dataset.tier) {
      modalState.tier = parseInt(activePageCard.dataset.tier, 10);
      modalState.qty = parseInt(activePageCard.dataset.qty || activePageCard.dataset.tier, 10);
    }

    updateModalBundleTiers();
    renderModalPairRows(size);
    updateModalLook(0, size);
    updateModalAtcButton(size);
  }

  function updateModalBundleTiers() {
    var bundleButtons = box ? box.querySelectorAll('.cm-sf__bundle-btn') : document.querySelectorAll('.cm-sf__bundle-btn');
    bundleButtons.forEach(function(btn) {
      var t = parseInt(btn.dataset.tier, 10);
      var isActive = (t === modalState.tier);
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      var pageCard = document.querySelector('.monteau-bundle-root .mb-card[data-tier="' + t + '"]');
      var pageSaleEl = pageCard ? pageCard.querySelector('.mb-price-sale') : null;
      var pageCompEl = pageCard ? pageCard.querySelector('.mb-price-compare') : null;

      var saleVal = (pageCard && pageCard.getAttribute('data-sale-price')) || (pageSaleEl && pageSaleEl.textContent.trim()) || '';
      var compVal = (pageCard && pageCard.getAttribute('data-compare-price')) || (pageCompEl && pageCompEl.textContent.trim()) || '';

      var priceSlot = btn.querySelector('.cm-sf__bundle-price');
      var compSlot = btn.querySelector('.cm-sf__bundle-compare');

      if (saleVal && priceSlot) {
        priceSlot.textContent = saleVal;
      }
      if (compSlot) {
        if (compVal && compVal !== saleVal) {
          compSlot.textContent = compVal;
          compSlot.style.display = 'inline';
        } else {
          compSlot.textContent = '';
          compSlot.style.display = 'none';
        }
      }
    });

    var giftsBanner = $('[data-cm-sf-gifts]');
    if (giftsBanner) {
      giftsBanner.hidden = (modalState.tier !== 3);
    }
  }

  function renderModalPairRows(size) {
    var container = $('[data-cm-sf-pair-rows]');
    if (!container) return;

    var colors = getAvailableColors();
    var html = '';

    for (var i = 0; i < modalState.qty; i++) {
      if (!modalState.pairs[i]) {
        var fallbackCol = colors[i] || 'Black';
        modalState.pairs[i] = { color: fallbackCol };
      }
      var curColor = modalState.pairs[i].color;

      var swatchesHtml = colors.map(function(c) {
        var cKey = c.toLowerCase().trim();
        var hex = COLOR_SWATCH_MAP[cKey] || '#888888';
        var isSel = (c.toLowerCase() === curColor.toLowerCase());
        return '<button type="button" class="cm-sf__swatch-dot' + (isSel ? ' is-active' : '') + '" ' +
               'data-cm-pair-swatch="' + i + '" data-color="' + c.replace(/"/g, '&quot;') + '" ' +
               'title="' + c.replace(/"/g, '&quot;') + '" ' +
               'style="background-color: ' + hex + ';" aria-label="' + c.replace(/"/g, '&quot;') + '">' +
               '</button>';
      }).join('');

      html += '<div class="cm-sf__pair-custom-row" data-pair-idx="' + i + '">' +
                '<div class="cm-sf__pair-custom-hd">' +
                  '<span class="cm-sf__pair-label">' +
                    '<span class="cm-sf__pair-tag">#' + (i + 1) + '</span> Pair ' + (i + 1) + ' in Size ' + size +
                  '</span>' +
                  '<span class="cm-sf__pair-color-val" data-pair-val="' + i + '">' + curColor + '</span>' +
                '</div>' +
                '<div class="cm-sf__swatches-row">' +
                  swatchesHtml +
                '</div>' +
              '</div>';
    }

    container.innerHTML = html;

    container.querySelectorAll('[data-cm-pair-swatch]').forEach(function(swatch) {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        var pairIdx = parseInt(swatch.getAttribute('data-cm-pair-swatch'), 10);
        var chosenColor = swatch.getAttribute('data-color');
        if (isNaN(pairIdx) || !chosenColor) return;

        modalState.pairs[pairIdx].color = chosenColor;

        var row = swatch.closest('.cm-sf__pair-custom-row');
        if (row) {
          row.querySelectorAll('.cm-sf__swatch-dot').forEach(function(s) {
            s.classList.toggle('is-active', s === swatch);
          });
          var valEl = row.querySelector('[data-pair-val]');
          if (valEl) valEl.textContent = chosenColor;
        }

        updateModalLook(pairIdx, size);
        syncColorToPage(pairIdx, chosenColor);
      });
    });
  }

  function updateModalLook(pairIdx, size) {
    var p = modalState.pairs[pairIdx] || modalState.pairs[0];
    var col = p ? p.color : 'Black';
    var img = $('[data-cm-sf-img]');
    var cap = $('[data-cm-sf-color]');

    if (img && COLORS && COLORS[col.toLowerCase()]) {
      img.src = COLORS[col.toLowerCase()];
    }

    if (cap) {
      cap.hidden = false;
      cap.textContent = 'Pair #' + (pairIdx + 1) + ': ' + col + ' · ' + (size || chosen || 'L');
    }
  }

  function syncColorToPage(pairIdx, col) {
    try {
      var activeCard = document.querySelector('.monteau-bundle-root .mb-card.is-active');
      if (!activeCard) return;
      var rows = activeCard.querySelectorAll('.mb-pair-row');
      var row = rows[pairIdx];
      if (!row) return;

      var hiddenInput = row.querySelector('.mb-hidden-color');
      if (hiddenInput) {
        hiddenInput.value = col;
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var label = row.querySelector('.mb-color-name');
      if (label) label.textContent = col;

      var thumb = row.querySelector('.mb-color-thumb');
      if (thumb && COLORS && COLORS[col.toLowerCase()]) {
        thumb.src = COLORS[col.toLowerCase()];
      }
    } catch(err) {}
  }

  function updateModalAtcButton(size) {
    var atcBtn = $('[data-cm-sf-atc]');
    if (!atcBtn) return;

    var activeBtn = box ? box.querySelector('.cm-sf__bundle-btn.is-active') : document.querySelector('.cm-sf__bundle-btn.is-active');
    var priceEl = activeBtn ? activeBtn.querySelector('.cm-sf__bundle-price') : null;
    var compEl = activeBtn ? activeBtn.querySelector('.cm-sf__bundle-compare') : null;

    var saleText = priceEl ? priceEl.textContent.trim() : '';
    var compText = compEl ? compEl.textContent.trim() : '';

    var pairWord = modalState.qty === 1 ? '1 pair' : modalState.qty + ' pairs';
    var szText = size || chosen || 'L';
    var labelText = 'Add ' + pairWord + ' in Size ' + szText + ' to cart';

    var html = '<span class="cm-sf-atc-inner">' +
                 '<span class="cm-sf-atc-label">' + labelText + '</span>';

    if (saleText) {
      html += '<span class="cm-sf-atc-prices">' +
                '<span class="cm-sf-atc-dash" aria-hidden="true">—</span>' +
                '<span class="cm-sf-atc-sale">' + saleText + '</span>';
      if (compText && compText !== saleText) {
        html += '<span class="cm-sf-atc-compare">' + compText + '</span>';
      }
      html += '</span>';
    }

    html += '</span>';
    atcBtn.innerHTML = html;
  }

  function onTierSelect(tierNum) {
    modalState.tier = tierNum;
    modalState.qty = (tierNum === 3 ? 3 : (tierNum === 2 ? 2 : 1));

    updateModalBundleTiers();
    renderModalPairRows(chosen || 'L');
    updateModalLook(0, chosen || 'L');
    updateModalAtcButton(chosen || 'L');

    try {
      var pageCard = document.querySelector('.monteau-bundle-root .mb-card[data-tier="' + tierNum + '"]');
      if (pageCard) pageCard.click();
    } catch(err) {}
  }

  function addToCart() {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'size_finder_add_to_cart',
        chosen_size: chosen,
        recommended_size: (window.__cmSfUserFit && window.__cmSfUserFit.recommended) || chosen,
        fit_type: (window.__cmSfUserFit && window.__cmSfUserFit.fitType) || 'direct',
        bundle_tier: modalState.tier,
        bundle_qty: modalState.qty
      });
    } catch(err) {}

    var atcBtn = $('[data-cm-sf-atc]');
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.innerHTML = '<span class="cm-sf-atc-inner"><span class="cm-sf-atc-label">Adding to cart...</span></span>';
    }

    var itemsToAdd = [];
    var tierTitles = {
      1: '1 Pair',
      2: '2 Pairs (Save 50%)',
      3: '3 Pairs + 2 Gifts (Save 60%)'
    };
    var currentTierTitle = tierTitles[modalState.tier] || 'Bundle Offer';

    for (var i = 0; i < modalState.qty; i++) {
      var pCol = (modalState.pairs[i] && modalState.pairs[i].color) || 'Black';
      var matched = resolveVariantForColorAndSize(pCol, chosen);
      if (matched) {
        itemsToAdd.push({
          id: matched.id,
          quantity: 1,
          properties: {
            'Bundle': currentTierTitle,
            ['Pair #' + (i + 1)]: pCol + ' / ' + chosen,
            '_size_finder_recommended': chosen
          }
        });
      }
    }

    // Add free gifts if Tier 3
    if (modalState.tier === 3) {
      var bundleRoot = document.querySelector('.monteau-bundle-root');
      if (bundleRoot && bundleRoot.getAttribute('data-show-gifts') !== 'false') {
        var g1Id = parseInt(bundleRoot.getAttribute('data-gift1-id') || '54385340186952', 10);
        var g1Title = bundleRoot.getAttribute('data-gift1-title') || '3D sleeve';
        var g2Id = parseInt(bundleRoot.getAttribute('data-gift2-id') || '0', 10);
        var g2Title = bundleRoot.getAttribute('data-gift2-title') || '$10 Gift Card';

        if (g1Id && !isNaN(g1Id)) {
          itemsToAdd.push({
            id: g1Id,
            quantity: 1,
            properties: {
              '_free_gift': 'true',
              'Promotion': 'Free ' + g1Title + ' with Bundle'
            }
          });
        }
        if (g2Id && !isNaN(g2Id)) {
          itemsToAdd.push({
            id: g2Id,
            quantity: 1,
            properties: {
              '_free_gift': 'true',
              'Promotion': 'Free ' + g2Title + ' with Bundle'
            }
          });
        }
      }
    }

    if (itemsToAdd.length === 0) {
      var pageAtc = (scope || document).querySelector('.mb-atc-pill-btn') ||
                    (scope || document).querySelector('form[action*="/cart/add"] [type=submit]');
      close();
      if (pageAtc) {
        setTimeout(function() { pageAtc.click(); }, 60);
      }
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: itemsToAdd })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      close();
      if (window.cmRefreshCart) {
        window.cmRefreshCart(function() {
          if (window.cmOpenCart) window.cmOpenCart();
        });
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function(err) {
      console.error('[Size Finder] Add to cart error:', err);
      var pageAtc = (scope || document).querySelector('.mb-atc-pill-btn') ||
                    (scope || document).querySelector('form[action*="/cart/add"] [type=submit]');
      close();
      if (pageAtc) {
        setTimeout(function() { pageAtc.click(); }, 60);
      }
    });
  }

  /* ---------- OPEN / CLOSE ---------- */
  function open(btn) {
    if (!box) init();
    if (!box) return;

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'size_finder_open',
        product_title: (box.querySelector('.cm-sf__ey') && box.querySelector('.cm-sf__ey').textContent.trim()) || '3D WEAVE LEGGINGS'
      });
    } catch(err) {}

    scope = btn.closest('.shopify-section') || btn.closest('.monteau-bundle-root') || document;
    box.hidden = false;
    document.documentElement.classList.add('cm-lock');
    document.body.classList.add('has-modal-open');

    try {
      var activePageCard = document.querySelector('.monteau-bundle-root .mb-card.is-active');
      if (activePageCard && activePageCard.dataset.tier) {
        modalState.tier = parseInt(activePageCard.dataset.tier, 10);
        modalState.qty = parseInt(activePageCard.dataset.qty || activePageCard.dataset.tier, 10);
      }
    } catch(err) {}

    updateModalBundleTiers();
    mountK();

    if (chosen) {
      applySize(chosen);
      renderModalStep2(chosen);
      look();
    }

    setTimeout(function() {
      var wInput = $('[data-cm-sf-w]');
      if (wInput) wInput.focus({ preventScroll: true });
    }, 80);
  }

  function close() {
    if (!box) return;
    unmountK();
    box.hidden = true;
    document.documentElement.classList.remove('cm-lock');
    document.body.classList.remove('has-modal-open');
  }

  function init() {
    var newBox = document.querySelector('.shopify-section [data-cm-sf]') || document.querySelector('[data-cm-sf]');
    if (!newBox) return;

    if (box && box !== newBox && box.parentNode === document.body) {
      box.parentNode.removeChild(box);
    }
    box = newBox;

    try {
      var colEl = document.querySelector('[data-cm-sf-colors]');
      COLORS = JSON.parse((colEl && colEl.textContent) || '{}');
    } catch (e) {
      COLORS = {};
    }

    if (box.parentNode !== document.body) {
      document.body.appendChild(box);
    }

    if (box.dataset.cmSfInited === 'true') {
      table();
      return;
    }
    box.dataset.cmSfInited = 'true';

    table();

    box.querySelectorAll('[data-cm-sf-unit]').forEach(function(b) {
      var isOn = (b.dataset.cmSfUnit === unit);
      b.classList.toggle('is-on', isOn);
      b.setAttribute('aria-selected', isOn ? 'true' : 'false');
    });

    var hUsInit = $('[data-cm-sf-h-us]'), hMetricInit = $('[data-cm-sf-h-metric]');
    if (hUsInit) {
      hUsInit.hidden = unit !== 'us';
      hUsInit.style.display = (unit === 'us' ? 'grid' : 'none');
    }
    if (hMetricInit) {
      hMetricInit.hidden = unit === 'us';
      hMetricInit.style.display = (unit === 'metric' ? 'flex' : 'none');
    }

    // Input listener
    box.addEventListener('input', function(e) {
      if (!e.target.closest('[data-cm-sf-kslot]')) {
        calc();
      }
    });

    // Click handler inside modal
    box.addEventListener('click', function(e) {
      // Unit toggle
      var u = e.target.closest('[data-cm-sf-unit]');
      if (u) {
        var next = u.dataset.cmSfUnit;
        if (next === unit) return;
        var w = $('[data-cm-sf-w]'), h = $('[data-cm-sf-hips]');
        var ftEl = $('[data-cm-sf-ft]'), inchEl = $('[data-cm-sf-inch]'), cmEl = $('[data-cm-sf-cm]');

        if (w && w.value) w.value = next === 'us' ? r0(num(w) * 2.2046) : r0(num(w) / 2.2046);
        if (h && h.value) h.value = next === 'us' ? (num(h) / 2.54).toFixed(1) : r0(num(h) * 2.54);

        // Height conversion between US (ft + in) and Metric (cm)
        if (next === 'metric') {
          var ftVal = ftEl ? num(ftEl) : 0;
          var inVal = inchEl ? num(inchEl) : 0;
          if (ftVal > 0 || inVal > 0) {
            var totalCm = Math.round((ftVal * 12 + inVal) * 2.54);
            if (cmEl) cmEl.value = totalCm;
          }
        } else {
          var cmVal = cmEl ? num(cmEl) : 0;
          if (cmVal > 0) {
            var totalIn = cmVal / 2.54;
            var ftOut = Math.floor(totalIn / 12);
            var inOut = Math.round(totalIn % 12);
            if (inOut === 12) { ftOut += 1; inOut = 0; }
            if (ftEl) ftEl.value = ftOut;
            if (inchEl) inchEl.value = inOut;
          }
        }

        unit = next;
        box.querySelectorAll('[data-cm-sf-unit]').forEach(function(b) {
          var isOn = (b === u);
          b.classList.toggle('is-on', isOn);
          b.setAttribute('aria-selected', isOn ? 'true' : 'false');
        });

        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'size_finder_unit_change',
            unit_system: unit
          });
        } catch(err) {}

        var wu = $('[data-cm-sf-wu]'), hu = $('[data-cm-sf-hu]');
        if (wu) wu.textContent = unit === 'us' ? 'lbs' : 'kg';
        if (hu) hu.textContent = unit === 'us' ? 'in' : 'cm';
        if (w) w.placeholder = unit === 'us' ? '160' : '72';
        if (h) h.placeholder = unit === 'us' ? '40' : '100';

        var hUs = $('[data-cm-sf-h-us]'), hMetric = $('[data-cm-sf-h-metric]');
        if (hUs) {
          hUs.hidden = unit !== 'us';
          hUs.style.display = (unit === 'us' ? 'grid' : 'none');
        }
        if (hMetric) {
          hMetric.hidden = unit === 'us';
          hMetric.style.display = (unit === 'metric' ? 'flex' : 'none');
        }

        table();
        calc();
        return;
      }

      // Alternative size toggle (Snugger / Best fit)
      var a = e.target.closest('[data-cm-sf-alt-size]');
      if (a) {
        box.querySelectorAll('[data-cm-sf-alt-size]').forEach(function(b) {
          b.classList.toggle('is-on', b === a);
        });
        var altSize = a.dataset.cmSfAltSize;
        var altLabel = a.textContent.indexOf('Snugger') > -1 ? 'Snugger' : 'Best fit';
        if (window.__cmSfUserFit) {
          window.__cmSfUserFit.chosen = altSize;
          window.__cmSfUserFit.fitType = altLabel;
        }
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'size_finder_fit_preference',
            chosen_size: altSize,
            fit_preference: altLabel
          });
        } catch(err) {}
        choose(altSize);
        return;
      }

      // Bundle Tier button click
      var bundleBtn = e.target.closest('.cm-sf__bundle-btn');
      if (bundleBtn) {
        e.preventDefault();
        var tNum = parseInt(bundleBtn.getAttribute('data-tier'), 10);
        if (!isNaN(tNum)) {
          onTierSelect(tNum);
        }
        return;
      }

      // Add to cart inside drawer
      if (e.target.closest('[data-cm-sf-atc]')) {
        addToCart();
        return;
      }

      // Close modal
      if (e.target.closest('[data-cm-sf-close]')) {
        close();
      }
    });
  }

  // Global trigger delegation
  document.addEventListener('click', function(e) {
    var b = e.target.closest('[data-cm-sf-open]');
    if (b && (!box || !box.contains(b))) {
      e.preventDefault();
      open(b);
    }
  });

  // Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && box && !box.hidden) {
      close();
    }
  });

  // Theme Editor lifecycle events
  document.addEventListener('shopify:section:load', function() {
    init();
  });
  document.addEventListener('shopify:block:select', function(e) {
    if (e.target && (e.target.matches('.monteau-size-finder-block') || e.target.querySelector('[data-cm-sf-open]'))) {
      var trigger = e.target.querySelector('[data-cm-sf-open]');
      if (trigger) open(trigger);
    }
  });
  document.addEventListener('shopify:block:deselect', function(e) {
    if (e.target && (e.target.matches('.monteau-size-finder-block') || e.target.querySelector('[data-cm-sf-open]'))) {
      close();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
